var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallHashtagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.141,
    height: 17.19,
    viewBox: "0 0 15.141 17.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smallHashtagIcon",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11224",
    "data-name": "Path 11224",
    d: "M36.382,982.362l-1.13,4.672H31.786v.849h3.256L33.6,993.83H31v.849h2.4l-1.13,4.672h.823l1.13-4.672h6.254l-1.13,4.672h.823l1.13-4.672h3.858v-.849H41.493l1.45-5.947h3v-.849h-2.8l1.143-4.672h-.823l-1.13,4.672H36.062l1.143-4.672h-.823Zm-.516,5.522H42.12l-1.438,5.947H34.416Z",
    transform: "translate(-31 -982.362)",
    fill: "var(--mainColor)",
    stroke: "var(--mainColor)",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallHashtagIcon);
export default __webpack_public_path__ + "static/media/smallHashtagIcon.65260bf865de5066059ea657e024a1c2.svg";
export { ForwardRef as ReactComponent };